import {
  EXAM_COURSE_LANGUAGE_TEXT,
  EXAM_COURSE_TYPE_TEXT,
} from '@exam-center/exam-course-management';
import { type ExamCourseLanguage, type ExamCourseType } from '@exam-center/graphql';
import { EllipsisText, type GridColDef } from '@shared/components';

export interface ExamCenterCourseAssignmentListItem {
  id: string;
  examId: string;
  code: string;
  name: string;
  type: ExamCourseType;
  language: ExamCourseLanguage;
}

export const columns: GridColDef<ExamCenterCourseAssignmentListItem>[] = [
  {
    field: 'examId',
    headerName: 'ExamID',
    sortable: false,
    width: 100,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'code',
    headerName: 'Code',
    sortable: false,
    width: 100,
    headerAlign: 'center',
    align: 'center',
    renderCell: ({ row }) => {
      const { code } = row;
      return <EllipsisText>{code}</EllipsisText>;
    },
  },
  {
    field: 'name',
    headerName: 'Name',
    sortable: false,
    flex: 1,
    renderCell: ({ row }) => {
      const { name } = row;
      return <EllipsisText variant='body1Semibold'>{name}</EllipsisText>;
    },
  },
  {
    field: 'type',
    headerName: 'Type',
    sortable: false,
    width: 80,
    renderCell: ({ row }) => {
      const { type } = row;
      return <EllipsisText>{EXAM_COURSE_TYPE_TEXT[type]}</EllipsisText>;
    },
  },
  {
    field: 'language',
    headerName: 'Language',
    sortable: false,
    width: 94,
    renderCell: ({ row }) => {
      const { language } = row;
      return <EllipsisText>{EXAM_COURSE_LANGUAGE_TEXT[language]}</EllipsisText>;
    },
  },
];
